import Reducer from './reducer';

export default Reducer;